document.addEventListener("DOMContentLoaded", function () {
  new Swiper(".locations-swiper", {
    direction: "vertical",
    slidesPerView: "auto",
    autoHeight: true,
    loop: true,
    autoplay: {
      delay: 10000,
      disableOnInteraction: false,
    },
    pagination: {
      el: ".locations-pagination",
      clickable: true,
    }
  });

  const featureElements = document.querySelectorAll('[data-swiper-feature-id]');

  if (featureElements.length > 0) {
    featureElements.forEach(element => {
      const featureId = element.getAttribute('data-swiper-feature-id');
      console.log(`Found swiper element with ID: ${featureId}`);

      new Swiper(`[data-swiper-feature-id="${featureId}"] .features-swiper`, {
        direction: "vertical",
        slidesPerView: "auto",
        autoHeight: true,
        loop: true,
        autoplay: {
          delay: 10000,
          disableOnInteraction: false,
        },
        pagination: {
          el: `[data-swiper-feature-id="${featureId}"] .features-pagination`,
          clickable: true,
        }
      });
    });
  }

  const quotesVerticalElements = document.querySelectorAll('[data-swiper-quotes-vertical-id]');

  if (quotesVerticalElements.length > 0) {
    quotesVerticalElements.forEach(element => {
      const quoteVerticalId = element.getAttribute('data-swiper-quotes-vertical-id');
      console.log(`Found swiper element with ID: ${quoteVerticalId}`);

      new Swiper(`[data-swiper-quotes-vertical-id="${quoteVerticalId}"] .quotes-swiper`, {
        direction: "vertical",
        slidesPerView: "auto",
        autoHeight: true,
        loop: true,
        autoplay: {
          delay: 10000,
          disableOnInteraction: false,
        },
        pagination: {
          el: `[data-swiper-quotes-vertical-id="${quoteVerticalId}"] .quotes-pagination`,
          clickable: true,
        }
      });
    });
  }

  const quotesHorizontalElements = document.querySelectorAll('[data-swiper-quotes-horizontal-id]');

  if (quotesHorizontalElements.length > 0) {
    quotesHorizontalElements.forEach(element => {
      const quoteHorizontalId = element.getAttribute('data-swiper-quotes-horizontal-id');
      console.log(`Found swiper element with ID: ${quoteHorizontalId}`);

      new Swiper(`[data-swiper-quotes-horizontal-id="${quoteHorizontalId}"] .quotes-swiper`, {
        slidesPerView: "auto",
        autoHeight: true,
        loop: true,
        autoplay: {
          delay: 10000,
          disableOnInteraction: false,
        },
        pagination: {
          el: `[data-swiper-quotes-horizontal-id="${quoteHorizontalId}"] .quotes-pagination`,
          clickable: true,
        }
      });
    });
  }

  new Swiper(".news-swiper", {
    slidesPerView: "auto",
    autoHeight: true,
    loop: true,

    autoplay: {
      delay: 10000,
      disableOnInteraction: false,
    },
    pagination: {
      el: ".news-pagination",
      clickable: true,
    }
  });
});
